import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/getting-started"
        }}>{`Getting Started`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/provided-fields"
        }}>{`Provided Fields`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/text"
            }}>{`text`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/number"
            }}>{`number`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/select"
            }}>{`select`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/checkbox"
            }}>{`checkbox`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/checkbox_group"
            }}>{`checkbox_group`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/list"
            }}>{`list`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/provided-fields/object"
            }}>{`object`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/custom-fields"
        }}>{`Custom Fields`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/styling"
        }}>{`Styling`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/reforml/material-ui"
            }}>{`Material UI`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/reduce-fields"
        }}>{`Reduce Fields`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/validation"
        }}>{`Validation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reforml/show-if"
        }}>{`Show If`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      